export default `
	guid
	created_at
	updated_at
	booking_date
	kind
	transport_kind
	scan_qr_code_is_custom
	scan_qr_code
	reason
	status
	active
`;
